/* import __COLOCATED_TEMPLATE__ from './topic-trends.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { AsyncData } from 'embercom/resources/utils/async-data';
import { use } from 'ember-resources/util/function-resource';
import {
  fetchTrendingTopics,
  type TrendingTopic,
} from './topic-trends/trending-topics-data-resources';

export default class TopicTrends extends Component {
  @service declare appService: any;
  @service declare intl: IntlService;
  @service declare intercomEventService: $TSFixMe;
  @service declare permissionsService: any;

  @use trendingTopics = AsyncData<TrendingTopic[]>(({ abortSignal }) => {
    // NOTE: synthetic data is not available for this endpoint yet
    return fetchTrendingTopics(this.appService.app.id, false, abortSignal);
  });

  get serializedReport() {
    return {
      id: 'topic-trends',
      date_range: {
        selection: 'past_week',
      },
    };
  }

  get shouldShowEmptyState() {
    return !this.trendingTopics.isLoading && this.trendingTopics.value?.length === 0;
  }

  get canAccessDrillIn() {
    return this.permissionsService.currentAdminCan('can_reporting__drillin__access');
  }

  @action
  onShowConversationExplorer(_topic: TrendingTopic) {
    // TODO: Implement
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends': typeof TopicTrends;
  }
}
